import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getData, getInProgress, getWorkSpaceId } from "./redux/selectors";
import WorkSpaceEditorPanel from "./workSpaceEditorPanel";
const mapStateToProps = (state) => ({
    inProgress: getInProgress(state),
    data: getData(state),
    workSpaceId: getWorkSpaceId(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (workSpaceId) => dispatch(actionCreators.getWorkSpace(workSpaceId)),
    onClose: () => dispatch(actionCreators.setWorkSpaceId(undefined))
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkSpaceEditorPanel);
